import { FieldRow, FieldValue } from '~/components/common/detailFields';
import { HeaderField } from '~/components/common/HeaderField';
import { useServiceProvider } from '~/data/hooks/useServiceProvider';
import type { CarInProperty } from '~/data/schemas/car';
import type { API_Compliance } from '~/data/schemas/compliance';

/**
 * How the car is serviced — the Service card on Service & Performance. Only what the
 * unit record doesn't already state: the provider comes from the compliance read and the
 * contract behind it, and the frequency is a term of the service arrangement rather than
 * a property of the machine.
 */
export function ElevatorIdentityFields({
  compliance,
  kpis,
  kpisLoading,
}: {
  compliance: API_Compliance | null;
  kpis: CarInProperty | null;
  kpisLoading: boolean;
}) {
  // The grid resolves the provider's name the same way, a row at a time — the
  // id is all either read carries.
  const { data: serviceProvider, isLoading: providerLoading } = useServiceProvider(
    compliance?.serviceProviderId ?? kpis?.serviceProviderId ?? null,
  );

  const loaded = !kpisLoading;

  return (
    <FieldRow>
      <HeaderField label="Service provider">
        <FieldValue
          loaded={compliance !== null && !providerLoading}
          value={serviceProvider?.name}
          fallback="Not under contract"
        />
      </HeaderField>

      <HeaderField label="Maintenance frequency">
        <FieldValue loaded={loaded} value={kpis?.maintenanceFrequency} />
      </HeaderField>
    </FieldRow>
  );
}
